const state = {
  attachments: [],
}

export default state
